import { render, staticRenderFns } from "./OrderingService.vue?vue&type=template&id=b2ca42dc&scoped=true&"
import script from "./OrderingService.vue?vue&type=script&lang=js&"
export * from "./OrderingService.vue?vue&type=script&lang=js&"
import style0 from "./OrderingService.vue?vue&type=style&index=0&id=b2ca42dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ca42dc",
  null
  
)

export default component.exports